const preauthSchema = Object.seal({
    feilds: [{
        id: 1,
        name: 'payer',
        title: 'Payer *',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select Payer',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Payer'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 mt-3'
    },{
        id: 2,
        name: 'zone',
        title: ' Zone',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select Zone',
        icon: 'user',
        rules: [
            // {
            //     test: (value) => {
            //         return (value !== null && value.length > 0);
            //     },
            //     message: 'Please Select Zone'
            // }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4 mt-3' 
    },
     {
        id: 3,
        name: 'insurance_company_name',
        title: 'Insurance Company',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select Insurance Company',
        icon: 'user',
        rules: [
            // {
            //     test: (value) => {
            //         return (value !== null && value.length > 0);
            //     },
            //     message: 'Please Insurance Company'
            // }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4 mt-3 mb-4'
     }
    ]
})

const preauthFileSchema = {
    feilds: [{
        id: 1,
        name: 'pre-auth_file_access',
        title: 'The following selected documents will be uploaded into remedinet:',
        visible: false,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': 'Access File',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" },{ 'id': 2, 'text': '#', width: "5%" }, { 'id': 3, 'text': 'Document Name', width: "90%" },
            // { 'id': 3, 'text': 'File Uploaded to RN ?', width: "10%" },{ 'id': 3, 'text': 'Uploaded Time', width: "15%" }
        ],
            'table_body': [
            //     {
            //     'id': 1,
            //     'feilds':[
            //     {
            //         id: 1,
            //         name: 'file_access',
            //         title: 'File_access',
            //         visible: true,
            //         icon: 'number',
            //         element: 'checkbox',
            //         required: true,
            //         type: 'checkbox',
            //         placeholder: 'Consider',
            //         rules: [],
            //         errors: [],
            //         value: null,
            //         valid: false,
            //         state: '',
            //         disable: false,
            //         className: 'col-3',
            //         row_group: 'routine',
            //         table: 'pre-auth_file_access',
            // },
            // {
            //     id: 1,
            //     name: 'document_name',
            //     title: 'Document Name',
            //     visible: true,
            //     icon: 'number',
            //     element: 'a',
            //     required: true,
            //     type: 'number',
            //     placeholder: 'Document Name',
            //     rules: [],
            //     errors: [],
            //     value: null,
            //     valid: false,
            //     state: '',
            //     disable: true,
            //     className: 'col-3',
            //     row_group: 'routine',
            //     table: 'pre-auth_file_access',
            // },
            // {
            //     id: 2,
            //     name: 'is_rn_file_uploaded',
            //     title: 'File Uploaded to RN ?',
            //     visible: true,
            //     icon: 'number',
            //     element: 'text',
            //     required: true,
            //     type: 'number',
            //     placeholder: 'File Uploaded to RN ?',
            //     rules: [],
            //     errors: [],
            //     value: null,
            //     valid: false,
            //     state: '',
            //     disable: true,
            //     className: 'col-3',
            //     row_group: 'routine',
            //     table: 'pre-auth_file_access',
            // },{
            //     id: 1,
            //     name: 'rn_uploaded_time',
            //     title: 'Uploaded Time',
            //     visible: true,
            //     icon: 'number',
            //     element: 'text',
            //     required: true,
            //     type: 'number',
            //     placeholder: 'Document Name',
            //     rules: [],
            //     errors: [],
            //     value: null,
            //     valid: false,
            //     state: '',
            //     disable: true,
            //     className: 'col-3',
            //     row_group: 'routine',
            //     table: 'pre-auth_file_access',
            // },
        // ]
        // }
            ],
            'add_more_feilds': [{
                    id: 1,
                    name: 'file_access',
                    title: 'File_access',
                    visible: true,
                    icon: 'number',
                    element: 'checkbox',
                    required: true,
                    type: 'checkbox',
                    placeholder: 'Consider',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'pre-auth_file_access',
            },
            {
                id: 2,
                name: 'document_name',
                title: 'Document Name',
                visible: true,
                icon: 'number',
                element: 'a',
                required: true,
                type: 'number',
                placeholder: 'Document Name',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'pre-auth_file_access',
            },
            // {
            //     id: 2,
            //     name: 'is_rn_file_uploaded',
            //     title: 'File Uploaded to RN ?',
            //     visible: true,
            //     icon: 'number',
            //     element: 'text',
            //     required: true,
            //     type: 'number',
            //     placeholder: 'File Uploaded to RN ?',
            //     rules: [],
            //     errors: [],
            //     value: null,
            //     valid: false,
            //     state: '',
            //     disable: true,
            //     className: 'col-3',
            //     row_group: 'routine',
            //     table: 'pre-auth_file_access',
            // },{
            //     id: 3,
            //     name: 'rn_uploaded_time',
            //     title: 'Uploaded Time',
            //     visible: true,
            //     icon: 'number',
            //     element: 'text',
            //     required: true,
            //     type: 'number',
            //     placeholder: 'Document Name',
            //     rules: [],
            //     errors: [],
            //     value: null,
            //     valid: false,
            //     state: '',
            //     disable: true,
            //     className: 'col-3',
            //     row_group: 'routine',
            //     table: 'pre-auth_file_access',
            // },
            ]
        }
    },]
}

export { preauthSchema,preauthFileSchema };